/**
 * Utility to send custom events to Google Analytics
 * find load events and send to GA
 * listen for click events and send to GA
 */

 var initializeAnalyticsEvents = function() {

	var loadEvents = document.querySelectorAll('[data-ga-load]');
	var clickEvents = document.querySelectorAll('[data-ga-click]');

	var sendCustomEventToGoogleAnalytics = function(category, action, label, value) {

		// local dev logging
		if (window.location.hostname.indexOf('localhost') !== -1) {
			console.log('sending GA event:', category, action, label, value);
		}

		// be careful to not cause problems if user blocks tracking
		try {
			if (typeof ga === 'function') {
				if (typeof ga.getAll === 'function') {
					var tracker = ga.getAll()[0];
					if (tracker) {
						if (!label) {
							tracker.send('event', category, action);
						} else if (typeof value != 'undefined') {
							tracker.send('event', category, action, label, value);
						} else {
							tracker.send('event', category, action, label);
						}
					}
				}
			}
		} catch (error) {
		}
	};

	// handle click events
	var sendClick = function(e) {
		var category = this.getAttribute('data-ga-category');
		var action = this.getAttribute('data-ga-action');
		var label = this.getAttribute('data-ga-label');
		var value = this.getAttribute('data-ga-value');
		if (!value || isNaN(value)) {
			sendCustomEventToGoogleAnalytics(category, action, label);
		} else {
			sendCustomEventToGoogleAnalytics(category, action, label, value);
		}
	};

	// send load events
	Array.prototype.forEach.call(loadEvents, function(el) {
		var category = el.getAttribute('data-ga-category');
		var action = el.getAttribute('data-ga-action');
		var label = el.getAttribute('data-ga-label');
		var value = el.getAttribute('data-ga-value');
		if (!value || isNaN(value)) {
			sendCustomEventToGoogleAnalytics(category, action, label);
		} else {
			sendCustomEventToGoogleAnalytics(category, action, label, value);
		}
	});

	// add click listeners
	Array.prototype.forEach.call(clickEvents, function(el) {
		el.addEventListener('click', sendClick);
	});

 };

 document.addEventListener('lichen:loaded', initializeAnalyticsEvents);
